<template>
    <div id="multimediaContainer">
        <section>
            <!-- <el-button :class="{'play': true, 'playing': simulatorStatus !== 1}" @click="runCode">
                <svg-icon v-if="simulatorStatus === 1" href="#codelab-play" :width="12" :height="12"></svg-icon>
                <svg-icon v-else href="#codelab-pause" :width="12" :height="12"></svg-icon>
                <span>{{ runCodeButtonlabel }}</span>
            </el-button> -->
            <span></span>
            <div class="right">
                <el-button circle @click="resetRobotPosition" :class="{'disabled': simulatorStatus === 2}" :title="$t('reset_robot_position')">
                    <svg-icon href="#codelab-reset-position" :width="11" :height="11"></svg-icon>
                </el-button>
                <el-button circle :class="{'active': lockCamera}" @click="lockCameraPosition" :title="$t('lock_camera')">
                    <svg-icon href="#codelab-lock-camera" :width="11" :height="11"></svg-icon>
                </el-button>
            </div>
        </section>
    </div>
</template>

<script>
import { obserState as obserStatePlay, update as obserStateUpdate } from '@/code-lab/component/robot-connect/play-button/microstate/playState.js'
import { mapState } from 'vuex'
const Blockly = window.Blockly;
export default {
    props: {
        scene: Object
    },
    data: () => ({
        simulatorStatus: 1,
        lockCamera: false,
        stopPlayTimer: null
    }),
    computed: {
        runCodeButtonlabel () {
            if (this.simulatorStatus === 1) {
                return this.$t("button.start_simulate");
            } else {
                return this.$t("button.stop_simulate");
            }
        },
        ...mapState({
            workSpace: "workSpace",
            statusOfPlay () {
                return obserStatePlay.simulator
            },
            genCode: "genCode",
            ttsLangCode: "ttsLangCode",
            script: state => state.projectData.script,
            materialsList: "materialsList"
        }),
        currentMachine () {
            return obserStatePlay.currentMachine
        }
    },
    watch: {
        currentMachine (n, o) {
            if (n === 1) {
                this.stopPlayOnSiomulator()
            }
            console.log(n, o, 'currentMachine')
        }
    },
    created () {
        this.api = this.scene.api;
        this.$watch("api.status", {
            handler (value) {
                console.log("api status:", value);
                this.simulatorStatus = value;
                if(value === 1) { 
                    obserStateUpdate({ key: "simulator", val: 3 })
                } else if(value === 2){
                    obserStateUpdate({ key: "simulator", val: 2 });
                }
            }
        });
        this.$watch("statusOfPlay", {
            handler (status, old) {
                if (status === 1) {
                    this.runCode()
                    
                } else if (status === 3) {
                    console.log(this.$t( "code-lab/component/machine-simulator/multimedia-control.vue_0" ))
                }
                console.log({ status, old })
            }
        });
    },
    methods: {
        stopPlayOnSiomulator () {
            this.scene.stopExcute();
            this.$nextTick(() => {
                obserStateUpdate({ key: "simulator", val: 3 })
            })
        },
         
        runCode () {
            this.stopPlayTimer && (clearTimeout(this.stopPlayTimer), this.stopPlayTimer = null);
            if (this.simulatorStatus === 1) {
                Blockly.selected && Blockly.selected.unselect();
                this.scene.excute(this.script, this.genCode, this.ttsLangCode, this.materialsList);
            } else {
                this.stopPlayOnSiomulator()
                Blockly.selected && Blockly.selected.unselect();

            }
        },
        resetRobotPosition () {
            if (this.simulatorStatus === 2) {
                return;
            }
            this.api.resetPosition()
        },
        lockCameraPosition () {
            this.api.cameraLock(!this.lockCamera)
            this.lockCamera = !this.lockCamera
        }
    },
}
</script>

<style lang="scss">
#multimediaContainer {
    width: 100%;
    position: absolute;
    z-index: 1;
    bottom: 10px;
    .el-button {
        background: $--codelab-primary-black-2;
        color: #ffffff;
        border: none;
        &.play {
            border-radius: 15px;
            padding: 9px 10px;
            margin-left: 23px;
            svg{
                margin-right: 4px;
                fill: #ffffff;
            }
            &.playing{
                background: #1BD3FF;
                color: #ffffff;
            }
        }
    }
    
    :nth-child(1) {
        .right {
            width: 100%;
            padding-right: 10px;
            text-align: right;
            .el-button{
                svg{
                    fill: #ffffff;
                }
                &:hover,&:active{
                    svg{
                        fill: #0ED3FF;
                    }
                }
                &.disabled{
                    svg{
                        fill: #000000;
                    }
                }
                &.active{
                    svg{
                        fill: #0ED3FF;
                    }
                }
            }
        }
    }
}
</style>
